import { render, staticRenderFns } from "./sendconfirm.component.vue?vue&type=template&id=3fd0660e&scoped=true"
import script from "./sendconfirm.component.vue?vue&type=script&lang=js"
export * from "./sendconfirm.component.vue?vue&type=script&lang=js"
import style0 from "./sendconfirm.component.vue?vue&type=style&index=0&id=3fd0660e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd0660e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDivider,VImg})
